import Vue from 'vue'
import Vuex from 'vuex'
import copyEn from './copy/en.js'
import copyGr from './copy/gr.js'
import VueResource from 'vue-resource'

Vue.use(VueResource)

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    lang: 'en',
    copy: {
      en: copyEn,
      gr: copyGr
    },
    form: {
      name: '',
      email: '',
      phone: '',
      link: '',
      record: '',
      anon: '',
      face: '',
      source: '',
      voice: '',
      terms: false,
      additional: '',
      when: '',
      where: '',
      submissiontype: 'Share link',
      files: []
    }
  },
  mutations: {
    toggleLang (state) {
      state.lang = state.lang === 'en' ? 'gr' : 'en'
    },
    updateForm (state, pay) {
      state.form[pay.key] = pay.value
    },
    addFile (state, f) {
      state.form.files.push(f)
    }
  },
  actions: {}
})
